import { PureComponent } from 'react';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { LeftIcon, RightIcon } from 'foundations-assets';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getFieldFromKey } from 'ContentComponents/cmv2/utils';
import { getNewOccurrenceValue, getOccurrenceFieldKey, isOccurrenceKey } from 'ContentComponents/cmv2/utils/occurrence';
import { getDeepValue } from 'ContentUtils/helpers/ObjectHelpers';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.occurrence.${key}`;
class OccurrencePrevNextButtons extends PureComponent {
  constructor(...args) {
    super(...args);
    this.hasMaxOccurrences = () => {
      const {
        fieldKey,
        moduleSpec
      } = this.props;
      const {
        fields
      } = moduleSpec;
      const occurrenceRowKey = getOccurrenceFieldKey(fieldKey);
      const field = getFieldFromKey(fields, occurrenceRowKey);
      if (field && field.occurrence) {
        const {
          max: maxOccurrences
        } = field.occurrence;
        const occurrenceValues = this.getOccurrenceTableValues(occurrenceRowKey);
        return occurrenceValues && maxOccurrences && occurrenceValues.length >= maxOccurrences;
      } else {
        return false;
      }
    };
    this.getOccurrenceTableValues = occurrenceRowKey => {
      const {
        fields,
        module
      } = this.props;
      const field = getFieldFromKey(fields, occurrenceRowKey) || {};
      const occurrenceTableKey = occurrenceRowKey.slice(0, -1);
      return getDeepValue(module, occurrenceTableKey) || field.default;
    };
    this.addAndSelectOccurrence = () => {
      const {
        fieldKey,
        fields,
        onFieldChange,
        setFieldKey
      } = this.props;
      const newFieldKey = [...fieldKey];
      const occurrenceFieldKey = getOccurrenceFieldKey(fieldKey);
      const occurrenceValues = this.getOccurrenceTableValues(occurrenceFieldKey);
      const fieldSpec = getFieldFromKey(fields, fieldKey);
      const occurrenceFieldKeyIndex = occurrenceFieldKey.length - 1;
      if (fieldSpec) {
        const newValue = getNewOccurrenceValue(fieldSpec);
        const newValues = [...occurrenceValues, newValue];
        const occurrenceParentFieldKey = occurrenceFieldKey.slice(0, -1);
        newFieldKey[occurrenceFieldKeyIndex] = newValues.length - 1;
        onFieldChange(occurrenceParentFieldKey, newValues);
        setFieldKey(newFieldKey);
      }
    };
    this.onPrevOrNextOccurrence = newOccurrenceIndex => {
      const {
        fieldKey,
        setFieldKey
      } = this.props;
      const newFieldKey = [...fieldKey];
      const occurrenceFieldKey = getOccurrenceFieldKey(fieldKey);
      const occurrenceFieldKeyIndex = occurrenceFieldKey.length - 1;
      newFieldKey[occurrenceFieldKeyIndex] = newOccurrenceIndex;
      setFieldKey(newFieldKey);
    };
  }
  renderPrevButton(occurrenceIndex) {
    const disablePrevButton = occurrenceIndex === 0;
    return /*#__PURE__*/_jsx(Button, {
      "data-test-id": "cmv2-repeater-prev-button",
      disabled: disablePrevButton,
      onClick: () => this.onPrevOrNextOccurrence(occurrenceIndex - 1),
      use: "transparent",
      size: "extra-small",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(LeftIcon, {
          color: disablePrevButton ? 'border-core-default' : 'fill-accent-blue-default',
          size: "100"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('prevButton')
        })]
      })
    });
  }
  renderAddButton() {
    if (this.hasMaxOccurrences()) return null;
    return /*#__PURE__*/_jsx(UIButton, {
      className: "p-all-0",
      "data-test-id": "cmv2-repeater-add-button",
      onClick: this.addAndSelectOccurrence,
      use: "transparent",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('addLink')
        })
      })
    });
  }
  renderNextButton(occurrenceIndex) {
    return /*#__PURE__*/_jsx(Button, {
      "data-test-id": "cmv2-repeater-next-button",
      onClick: () => this.onPrevOrNextOccurrence(occurrenceIndex + 1),
      use: "transparent",
      size: "extra-small",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('nextButton')
        }), /*#__PURE__*/_jsx(RightIcon, {
          color: "fill-accent-blue-default",
          size: "100"
        })]
      })
    });
  }
  render() {
    const {
      fieldKey
    } = this.props;
    if (!isOccurrenceKey(fieldKey)) return null;
    const occurrenceRowKey = getOccurrenceFieldKey(fieldKey);
    const occurrenceValues = this.getOccurrenceTableValues(occurrenceRowKey);
    const occurrenceIndex = occurrenceRowKey[occurrenceRowKey.length - 1];
    if (!Array.isArray(occurrenceValues)) return null;
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      justify: "between",
      className: "p-all-3",
      children: [this.renderPrevButton(occurrenceIndex), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('occurrenceIndex'),
          options: {
            currentIndex: occurrenceIndex + 1,
            totalCount: occurrenceValues.length
          }
        })
      }), occurrenceIndex === occurrenceValues.length - 1 ? this.renderAddButton() : this.renderNextButton(occurrenceIndex)]
    });
  }
}
export default OccurrencePrevNextButtons;